import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const ClosingCTASection = () => {
  // Social media links
  const socialLinks = [
    {
      name: 'Facebook',
      icon: 'Facebook',
      url: 'https://www.facebook.com/people/General-Union-of-Syrian-Students/61556795854406/?rdid=nEpNLZ2NtdfbaSYg&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1AAVKtJke2%2F'
    },
    {
      name: 'Instagram',
      icon: 'Instagram',
      url: 'https://www.instagram.com/guofsyrians'
    },
    {
      name: 'X',
      icon: 'X',
      url: 'https://x.com/guofsyrians'
    },
    {
      name: 'YouTube',
      icon: 'Youtube',
      url: 'https://www.youtube.com/@guofsyrian'
    }
  ];

  return (
    <section id="closing-cta" className="relative py-16 lg:py-24 bg-gradient-to-b from-background via-[#114845]/5 to-background overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-transparent"></div>
        <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-accent/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 left-1/4 w-96 h-96 bg-secondary/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <div className="bg-gradient-to-r from-primary/10 via-accent/10 to-success/10 border border-primary/20 rounded-2xl p-8 md:p-12 shadow-memorial">
            <div className="mb-8">
              <Icon name="Heart" size={48} className="text-primary mx-auto mb-4" />
            </div>
            
            <p className="font-body text-lg md:text-xl text-text-primary leading-relaxed mb-8 max-w-3xl mx-auto" dir="rtl">
              نرسّخ عبر هذا المؤتمر استدامة العمل المؤسسي لحفظ حقوق الطالب وإعلاء صوته. تابعوا مجريات الحدث عبر منصاتنا الرسمية.
            </p>

            {/* Social Media Links */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="flex flex-col items-center gap-4"
            >
              <p className="font-body text-sm md:text-base text-text-secondary mb-2" dir="rtl">
                روابط التواصل الاجتماعي للمؤتمر:
              </p>
              <div className="flex gap-4 justify-center">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 rounded-full flex items-center justify-center transition-all hover:scale-110 bg-gray-100 hover:bg-primary hover:text-white"
                    aria-label={social.name}
                  >
                    <Icon
                      name={social.icon}
                      size={20}
                      color="currentColor"
                    />
                  </a>
                ))}
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ClosingCTASection;
